import { render, staticRenderFns } from "./card-product.vue?vue&type=template&id=4501cb33&scoped=true"
import script from "./card-product.vue?vue&type=script&lang=js"
export * from "./card-product.vue?vue&type=script&lang=js"
import style0 from "./card-product.vue?vue&type=style&index=0&id=4501cb33&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4501cb33",
  null
  
)

export default component.exports